<template>
    <form-modal
        ref="formModal"
        :title="i18nNewExport"
        size="xl"
        :in-editing="true"
        :handle-close="handleCancel">
        <template v-slot:form>
            <form @submit.prevent="handleOk">
                <confirmation-form-modal
                    ref="confirmationFormModal"
                    :title="i18nExportKmJob"
                    :operation="'created'"
                />
                <b-row>
                    <b-col md="6">
                        <b-form-group
                            :label="i18nDate"
                            label-for="filter-started-at-date-time"
                            class="required label-pdv"
                            :invalid-feedback="getI18n('ERROR_CODES.invalid_period')"
                        >
                            <date-range-picker
                                :value.sync="dateRange"
                                :max-date="new Date()"
                                :max-range-in-days="maxRangeInDays"
                                :disabled="submitLoading"
                                :placeholder="getI18n('PLACEHOLDERS', 'select_the_period')"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            :label="i18nRegionals"
                            label-for="filter-regional"
                            class="label-pdv"
                        >
                            <multiSelectWithService
                                :id="'filter-regional'"
                                ref="regionalMultiselect"
                                v-model="modal.regionals"
                                :service="'pos-regionals'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="parameters"
                                :placeholder="getI18n('PLACEHOLDERS', 'select_regions')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-form-group
                            :label="i18nUser"
                            label-for="filter-user"
                            class="label-pdv"
                        >
                            <multiSelectWithService
                                :id="'filter-user'"
                                ref="userMultiselect"
                                v-model="modal.users"
                                :service="'users'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="usersParameters"
                                :placeholder="getI18n('PLACEHOLDERS', 'select_users')"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                                :label="i18nTeam"
                                label-for="filter-team"
                                class="label-pdv"
                            >
                            <multiSelectWithService
                                :id="'filter-team'"
                                ref="teamMultiselect"
                                v-model="modal.teams"
                                :service="'teams'"
                                :searchable="true"
                                :multiple="true"
                                :parameters="usersParameters"
                                :placeholder="getI18n('PLACEHOLDERS', 'select_teams')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-form-group
                            :label="i18nRole"
                            class="label-pdv"
                            label-for="filter-role"
                        >
                            <multiSelectWithService
                                :id="'filter-role'"
                                ref="roleMultiselect"
                                v-model="modal.roles"
                                :service="'roles'"
                                label="alias"
                                :searchable="true"
                                :multiple="true"
                                :parameters="parameters"
                                :placeholder="getI18n('PLACEHOLDERS', 'select_role')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>

                </b-row>
            </form>
        </template>
        <template v-slot:footer>
            <!-- <cancel-button
                ref="cancelButton"
                child-class="col-sm-4 float-left"
                :disabled="submitLoading"
                @onClick="handleCancel"
            /> -->
            <save-button
                ref="okButton"
                child-class="col-sm-4 flex justify-center float-right ml-3"
                :busy="submitLoading"
                :title="i18nGenerateReport"
                @onClick="handleOk"
            />
        </template>
    </form-modal>
</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import validationMixin from '@src/mixins/validation.vue'
    import fieldsValidation from '@src/mixins/fieldsValidation.vue'
    import FormModal from '@/src/components/FormModal.vue'
    import ConfirmationFormModal from '@src/components/ConfirmationFormModal'
    // import CancelButton from '@/src/components/CancelButton'
    import SaveButton from '@/src/components/SaveButton'
    import DateRangePicker from '@/src/components/DateRangePicker'
    import filterVuetable from '@src/mixins/filterVuetable'
    import ExportJobService from '@src/services/ExportJobService'
    import multiSelectWithService from '@src/components/multiSelectWithService'
    import moment from 'moment';

    const i18nKey = 'EXPORT_KM_JOBS'
    const i18nCommon = 'COMMON'

    export default {
        components: {
            FormModal,
            ConfirmationFormModal,
            DateRangePicker,
            // CancelButton,
            SaveButton,
            multiSelectWithService,
        },
        mixins: [
            validationMixin,
            swalFeedback,
            fieldsValidation,
            filterVuetable,
        ],
        props: {
            placeholder: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                i18nKey: i18nKey,
                i18nCommon: i18nCommon,
                dateRange: null,
                modal: {
                    start_date: moment().startOf('day').toDate(),
                    end_date: moment().startOf('day').toDate(),
                    regionals: [],
                    users: [],
                    teams: [],
                    roles: [],
                },
                maxRangeInDays: 30,
                submitLoading: false,
                tabIndex: 0,
                usersParameters: {
                    per_page: 1000,
                    page: 1,
                    orderBy: 'name',
                    sortedBy: 'asc',
                    active: true,
                },
                parameters: {
                    with_admin: true,
                    per_page: 1000,
                    page: 1,
                    orderBy: 'name',
                    sortedBy: 'asc',
                },
            }
        },
        validations: {
            modal: {
                start_date: {
                    required,
                    beforeEndDate(value, model) {
                        return value <= model.end_date
                    },
                    maxRangePeriod(value, model) {
                        return ((model.end_date - value) / 86400000) <= this.maxRangeInDays;
                    },
                },
                end_date: {
                    required,
                    afterStartDate(value, model) {
                        return value >= model.start_date
                    },
                },
            },
        },
        computed: {
            i18nDate() {
                return this.getI18n(i18nCommon, 'period')
            },
            i18nNewExport() {
                return this.getI18n(i18nKey, 'BUTTONS.new_export')
            },
            i18nGenerateReport() {
                return this.getI18n(i18nKey, 'BUTTONS.generate_report')
            },
            i18nExportKmJob() {
                return this.getI18nModified({
                    prefix: i18nKey,
                    suffix: 'TITLES.export_km_job',
                    modifier: 2,
                })
            },
            i18nInformation() {
                return this.getI18nModified({
                    prefix: 'COMMON.info',
                    modifier: 2,
                })
            },
            i18nQuestionnaire() {
                return this.getI18n('QUESTIONNAIRES', 'TITLES.questionnaire')
            },
            i18nBusinessUnit() {
                return this.getI18n(i18nCommon, 'business_unit')
            },
            i18nFlag() {
                return this.getI18n('POS', 'TITLES.flag')
            },
            i18nChain() {
                return this.getI18n('POS', 'TITLES.chain')
            },
            i18nRegionals() {
                return this.getI18n('POS', 'TITLES.regional')
            },
            i18nPos() {
                return this.getI18n('POS', 'TITLES.pos')
            },
            i18nUser() {
                return this.getI18n('USERS', 'TITLES.user')
            },
            i18nTeam() {
                return this.getI18n('TEAMS', 'TITLES.team')
            },
            i18nStateAndCity() {
                return this.getI18n(i18nCommon, 'state_and_city')
            },
            i18nStartedAt() {
                return this.getI18n(i18nKey, 'FIELDS.started_at_date_time')
            },
            i18nEndedAt() {
                return this.getI18n(i18nKey, 'FIELDS.ended_at_date_time')
            },
            i18nRole() {
                return this.getI18n('ROLES', 'TITLES.role')
            },
            i18nFrequency() {
                return this.getI18n('WORKSCHEDULES', 'TITLES.frequency')
            },
        },
        watch: {
            dateRange: {
                deep: true,
                handler(newValue) {
                    if (newValue && newValue.start && newValue.end) {
                        this.modal.start_date = newValue.start;
                        this.modal.end_date = newValue.end;
                        this.$v.modal.start_date.$touch();
                        this.$v.modal.end_date.$touch();
                    } else {
                        this.modal.start_date = null;
                        this.modal.end_date = null;
                    }
                },
            },
        },
        methods: {
            tabActivated(newTabIndex, oldTabIndex, event) {
                if (oldTabIndex === 0) {
                    this.$v.modal.$touch()
                    if (this.$v.modal.$invalid) {
                        event.preventDefault();
                    }
                }
            },
            showModal() {
                this.submitLoading = false
                this.tabIndex = 0
                this.cleanModal()
                this.$refs.formModal.show()
            },
            cleanModal() {
                this.dateRange = null;

                this.modal = Object.assign(this.modal, {
                    start_date: moment().startOf('day').toDate(),
                    end_date: moment().startOf('day').toDate(),
                    regionals: [],
                    users: [],
                    teams: [],
                    roles: [],
                })
            },
            resetValidation() {
                this.$nextTick(() => this.$v.$reset())
                this.clearAllResponseError()
            },
            handleCancel() {
                this.$refs.confirmationFormModal.showModal(true, this.handleClose)
            },
            handleClose(close) {
                if (!close) {
                    return;
                }
                this.resetValidation()
                this.$refs.formModal.hide()
            },
            handleOk() {
                this.$v.modal.$touch()
                if (!this.$v.modal.$invalid && !this.submitLoading) {
                    this.$refs.confirmationFormModal.showModal(false, this.handleSubmit)
                }
            },
            async handleSubmit(submit) {
                if (!submit) {
                    return;
                }

                this.submitLoading = true

                const parameters = this.formatParameters({
                    datetime_in: {
                        from: moment(this.modal.start_date).format('YYYY-MM-DD'),
                        to: moment(this.modal.end_date).format('YYYY-MM-DD'),
                    },
                    regional_id: this.modal.regionals.map((regional) => regional.id),
                    user_id: this.modal.users.map((user) => user.id),
                    team_id: this.modal.teams.map((team) => team.id),
                    role_id: this.modal.roles.map((role) => role.id),
                    export_type: 'work_schedule_km',
                    language: 'pt_BR',
                })

                const response = await ExportJobService.create(parameters)
                    .then((response) => response)
                    .catch((error) => error)

                const statusCode = response.status.toString()

                if (statusCode.charAt(0) === '2') {
                    this.$emit('refresh')
                    this.resetValidation()
                    this.$refs.formModal.hide()
                    this.positiveFeedback(this.i18nExportKmJob, 'created')
                    this.$router.push({ name: 'exportJobs', params: { newJobCreated: true } })
                }

                if (statusCode === '417') {
                    this.warningFeedback(this.i18nExportKmJob, response.data.message)
                }

                if (statusCode === '422') {
                    this.modalResponseErrors = response.data.errors
                }

                this.submitLoading = false
            },
        },
    }
</script>
